export default [
    {
      path: '/plans/drainage/list',
      name: 'plans.drainage.list',
      component: () => import('@/views/modules/plans/drainage-plan/plan-list/PlansList'),
      meta: {
        module: 'plans.drainage',
        pageTitle: 'List All drainage Plans',
        breadcrumb: [
          { text: 'List drainage Plans', active: true, },
          //{ text: 'Create Plan', to: {name: 'plans.rain.create'} }
        ],
      }
    },
  
  
    {
      path: '/plans/drainage/create',
      name: 'plans.drainage.create',
      component: () => import('@/views/modules/plans/drainage-plan/create/CreateDrainagePlan'),
      meta: {
        module: 'plans.drainage',
        pageTitle: 'Plan Create',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.drainage.list'} },
          { text: 'Create drainage' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/drainage/:id/edit',
      name: 'plans.drainage.edit',
      component: () => import('@/views/modules/plans/drainage-plan/edit/EditDrainagePlan'),
      meta: {
        module: 'plans.drainage',
        pageTitle: 'Drainge Plan Edit',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.drainage.list'} },
          { text: 'Edit Plan' , to: {name: 'plans.drainage.edit'}},
         
        ],
      }
    },
  ]
  